import React from "react";
import "../styles/Header.css"; // separate CSS for header

const Header: React.FC = () => {
  return (
    <header className="portal-header">
      <div className="portal-logo">
        <span className="portal-globe">🌐</span>
        <span>DOTS Ireland Simulator Portal</span>
      </div>
      <nav className="portal-nav">
        <a href="/">Home</a>
        <a href="/universities">University Applications</a>
        <a href="">Banking Services</a>
      </nav>
    </header>
  );
};

export default Header;
